export default __webpack_public_path__ + "static/media/background-barber-profile.ace41c83.jpg";